import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/train-setting',
            name: 'admin-train-setting',
            component: () => import(/* webpackChunkName: "page-admin-mall-management-train-setting" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "火车票抢票设置"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "微商城管理"
                                        },
                                        {
                                                  name: "火车票抢票设置"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
